import { Col, Row } from "antd";
import { useFormik } from "formik";
import { get, isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import useZipCodeCities from "shared/hooks/useZipCodeCities";
import { NAME_SPACES } from "shared/locales/constants";
import { CONTACT_POINT_SYSTEM } from "utils/constants";
import {
  bindInputProps,
  bindWebTextFieldInputProps,
} from "utils/helpers/input";
import ActionButtons from "../Components/ActionButtons";
import Header from "../Components/Header";
import Input from "../Components/Input";
import Layout from "../Components/Layout";
import Select from "../Components/Select";
import validation from "./validation";

function View({ telecoms, onNext, onBack }) {
  const { t } = useTranslation();

  const { handleSubmit, values, setFieldValue, ...formProps } = useFormik({
    initialValues: { telecoms },
    onSubmit: onNext,
    validationSchema: validation(
      t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
    ),
  });
  const zipCode = get(
    values,
    `telecoms.${CONTACT_POINT_SYSTEM.ZIP_CODE}.value`,
  );
  const { cities, loading: citiesLoading } = useZipCodeCities(zipCode);

  return (
    <Layout>
      <Header
        title="Passons à l’adhésion, nous avons besoin de quelques informations complémentaires"
        highlight="informations complémentaires"
        subtitle="Souscription : Informations complémentaires"
        onBack={onBack}
      />
      <Row justify="center">
        <Col xs={24} md={18}>
          <div className="grid--2 pb-16">
            <Input
              placeholder={"ex : 17, Rue de la victoire"}
              label={"Adresse"}
              {...bindWebTextFieldInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.ADDRESS}.value`,
                values,
                setFieldValue,
                ...formProps,
              })}
            />
            <Input
              disabled
              placeholder={"ex : 69001"}
              label={"Code postal"}
              {...bindInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.ZIP_CODE}.value`,
                values,
                ...formProps,
              })}
            />
          </div>
          <div className="grid--2">
            <Input
              placeholder={"ex : Rhône"}
              label={"Complément d’adresse"}
              {...bindWebTextFieldInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.COMPLEMENT}.value`,
                values,
                setFieldValue,
                ...formProps,
              })}
            />
            <Select
              disabled
              loading={citiesLoading}
              options={cities}
              placeholder={"Sélectionnez ..."}
              label={"Ville"}
              {...bindInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.CITY}.value`,
                values,
                ...formProps,
              })}
            />
          </div>
        </Col>
      </Row>

      <ActionButtons
        disabled={
          !get(values, `telecoms.${CONTACT_POINT_SYSTEM.ADDRESS}.value`) ||
          !isEmpty(formProps.errors)
        }
        onNext={handleSubmit}
        onBack={onBack}
      />
    </Layout>
  );
}

export default View;
